import gql from "graphql-tag";
import PinnablePostFields from "../../fragments/engagement/PinnablePostFields";

export default gql`
  mutation UnpinPostReply($objectId: ID!) {
    unpinPostReply(objectId: $objectId) {
      ...PinnablePostFields
    }
  }

  ${PinnablePostFields}
`;
